import PositionService from 'src/modules/position/positionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'POSITION_FORM';

const positionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: positionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PositionService.find(id);
      }

      dispatch({
        type: positionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: positionFormActions.INIT_ERROR,
      });

      getHistory().push('/position');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: positionFormActions.CREATE_STARTED,
      });

      await PositionService.create(values);

      dispatch({
        type: positionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.position.create.success'),
      );

      getHistory().push('/position');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: positionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: positionFormActions.UPDATE_STARTED,
      });

      await PositionService.update(id, values);

      dispatch({
        type: positionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.position.update.success'),
      );

      getHistory().push('/position');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: positionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default positionFormActions;
